import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus, Pencil, Eye, EyeOff } from "lucide-react";
import { api, euro, imgUrl, formatErr } from "@/lib/api";
import ProductForm from "./ProductForm";

export default function AdminProducts() {
  const [list, setList] = useState([]);
  const [editing, setEditing] = useState(null);

  const load = () => api.get("/admin/products").then((r) => setList(r.data));
  useEffect(() => { load(); }, []);

  const toggle = async (p) => {
    try {
      const { id, rating_avg, rating_count, order, created_at, ...rest } = p;
      await api.put(`/admin/products/${id}`, { ...rest, active: !p.active });
      load();
    } catch (e) {
      toast.error(formatErr(e));
    }
  };

  return (
    <div data-testid="admin-products">
      <button className="btn-red mb-6" onClick={() => setEditing({})} data-testid="admin-product-new-button"><Plus size={16} /> Nuovo servizio / prodotto</button>
      <div className="space-y-3">
        {list.map((p) => (
          <div key={p.id} className={`flex items-center gap-4 bg-[#18181C] border border-zinc-800 p-3 ${p.active ? "" : "opacity-50"}`} data-testid={`admin-product-${p.id}`}>
            <img src={imgUrl(p.image_url)} alt="" className="w-20 h-16 object-cover bg-zinc-900" />
            <div className="flex-1 min-w-0">
              <p className="font-display italic uppercase font-bold truncate">{p.name}</p>
              <p className="text-xs text-zinc-500">{p.category} · {p.active ? "Visibile" : "Nascosto"} · {p.rating_count} recensioni</p>
            </div>
            <span className="font-display italic font-black text-xl text-red-500">{euro(p.price)}</span>
            <button className="p-2 hover:text-red-500" onClick={() => toggle(p)} title={p.active ? "Nascondi" : "Mostra"} data-testid={`admin-product-toggle-${p.id}`}>{p.active ? <Eye size={18} /> : <EyeOff size={18} />}</button>
            <button className="p-2 hover:text-red-500" onClick={() => setEditing(p)} data-testid={`admin-product-edit-${p.id}`}><Pencil size={18} /></button>
          </div>
        ))}
      </div>
      <ProductForm product={editing} onClose={() => setEditing(null)} onSaved={() => { setEditing(null); load(); }} />
    </div>
  );
}
